var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { repeat } from 'lit/directives/repeat.js';
import { property } from 'lit/decorators.js';
import { query } from 'lit/decorators.js';
import { html, css } from 'lit';
import { stringDecoder, numberDecoder, customElement, PICBase, PIC } from '../Internals';
let PICDisplay = class PICDisplay extends PICBase {
    constructor() {
        super();
        this.width = 0;
        this.noteKey_ = '';
        this.comp_ = '';
        this.fileLst = [];
    }
    static get styles() {
        const defaultStyle = css `
        .inner-input {
            width: 100%;
            box-sizing: border-box;
            font-family: monospace;
        }
        p.head{
            font-size: 18px;
        }
        p {
            font-size: 16px;
            font-weight: bold;
            margin-block-start: 0px;
            margin-block-end: 0px;
            margin-inline-start: 0px;
            margin-inline-end: 0px;
        }
        `;
        return css `
            ${super.styles}
            ${defaultStyle}
        `;
    }
    focus() {
        this.fileDispFld.focus();
    }
    get submitValue() {
        return null;
    }
    validateSubmit() {
        return true;
    }
    connectedCallback() {
        super.connectedCallback();
        let requestStr = '/filestore/UploadFormFile?notekey=' + this.noteKey_ + '&company=' + this.comp_ + '&system=' + PIC.systemId;
        let xhr = new XMLHttpRequest();
        let ref = this;
        xhr.onload = function () {
            if (xhr.readyState === xhr.DONE) {
                if (xhr.status === 200) {
                    let response = xhr.responseText;
                    if (response != '' && response != 'No files found!') {
                        ref.fileLst = response.split(',');
                        ref.requestUpdate();
                    }
                }
            }
        };
        xhr.open("GET", requestStr, true);
        xhr.send();
    }
    renderFile(iFile, iIndex) {
        return html `<p>${iFile.replace(new RegExp(this.noteKey_ + '-', 'g'), '')}</p>`;
    }
    render() {
        return html `
            ${this.renderCSS(true)}
            <style>
                ${this.width > 0 ? html `:host { width: ${this.width}rem; }` : ''}
                input {
                    -webkit-user-select: auto;
                    -webkit-user-drag: none;
                    user-select: auto;
                }
            </style>
            <div id='fileDispFld'>
                <p class="head">Uploaded:</p>
                ${repeat(this.fileLst, (item, index) => this.renderFile(item, index))}
            </div>
        `;
    }
};
__decorate([
    property({ converter: numberDecoder })
], PICDisplay.prototype, "width", void 0);
__decorate([
    property({ converter: stringDecoder, attribute: 'notekey' })
], PICDisplay.prototype, "noteKey_", void 0);
__decorate([
    property({ converter: stringDecoder, attribute: 'comp' })
], PICDisplay.prototype, "comp_", void 0);
__decorate([
    query('#fileDispFld')
], PICDisplay.prototype, "fileDispFld", void 0);
PICDisplay = __decorate([
    customElement('pic-display')
], PICDisplay);
export { PICDisplay };
/*var fileLstFld = document.getElementById('filelist');

function myOnloadFunc() {
    var requestStr = '/filestore/UploadFormFile?notekey=a_123&company=picit&system=udv';
    var xhr = new XMLHttpRequest();
    xhr.addEventListener("load", downloadFileList, false);
    xhr.open("GET", requestStr, true);
    xhr.send();
}

function downloadFileList(event) {
    var response = event.target.responseText;
    if (response != "" && response != "No files found!") {
        fileLstFld.style.display = 'block';
        fileLstFld.innerHTML = "<Strong>Uploaded:</strong>";
        fileLstFld.innerHTML += "<br/>" + response.replace(new RegExp("a_123" + "-", 'g'), "").replace(new RegExp(",", 'g'), "<br/>");
    }
}
PIC.setTimeout(myOnloadFunc, 50);*/ 
//# sourceMappingURL=PICDisplay.js.map